import React from 'react';

import StepBackUIComponent from "../StepBackUIComponent";
import SequenceBackUIComponent from "../SequenceBackUIComponent";
import RunBackUIComponent from "../RunBackUIComponent";
import SequenceForwardUIComponent from "../SequenceFrowardUIComponent";
import StepForwardUIComponent from "../StepForwardUIComponent";
import RunForwardUIComponent from "../RunForwardUIComponent";
import SpeedPickerComponent from "../../reusable/SpeedPickerComponent";
import SpeedPickerUIComponent from "../SpeedPickerUIComponent";
import PauseUIComponent from "../PauseUIComponent";
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";

export const PlaybackUIBackComponent = () => {
    const { speedPickerIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);

    
    return (
        <div className='flex al-it-c'>
            <SequenceBackUIComponent />
            <StepBackUIComponent />
            <RunBackUIComponent />
            <div className={'player'}>
                <SpeedPickerComponent />
                <SpeedPickerUIComponent />
            </div>
        </div>
    )
};

export const PlaybackUIForwardComponent = () => {
    return (
        <div className='flex al-it-c'>
            <PauseUIComponent />
            <RunForwardUIComponent />
            <StepForwardUIComponent />
            <SequenceForwardUIComponent />
        </div>
    )
};